import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const IframeableContext = /*#__PURE__*/createContext({
  iframeableContext: {}
});

/**
 * Context for holding on to shared iframe context used when this app is embedded using ui-addon-iframeable
 *
 * @param {node || element || node[] || element[]} children     children that will be rendered to display the page
 * @param {Object} iframeableContext                            JS object that provides shared context variables
 * @returns {node || element || node[] || element[]}            children rendered inside of the context provider
 */

export const IframeableContextProvider = props => {
  const {
    children,
    iframeableContext
  } = props;
  const contextValue = {
    iframeableContext
  };
  return /*#__PURE__*/_jsx(IframeableContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useIframeableContext = () => {
  const context = useContext(IframeableContext);
  if (context === undefined) {
    console.error('Please provide IframeableContext in order to use this hook');
    return {};
  }
  return context;
};